module.exports = __webpack_public_path__ + "img/logo0.66e8a372.png";